<template>
  <header id="welcome-header">
    <div class="hero-bg">
      <video class="hero-video-fill" autoplay muted loop playsinline>
        <source src="@/assets/video/Monako_Final_2024.mp4" type="video/mp4">
      </video>
      <div class="hero-overlay" />
      <div class="hero-grain" />
    </div>

    <v-container class="hero-content">
      <div class="hero-top">
        <span class="brand-mark">AGH SOLAR BOAT</span>
        <span class="brand-meta">{{ $t('homepage.header.brand_meta') }}</span>
      </div>

      <div class="hero-mid">
        <div class="hero-copy">
          <h1 class="hero-title">
            <span class="hero-title-agh">AGH</span>
            <span class="hero-title-solar">Solar Boat</span>
          </h1>
          <h2 class="hero-team">Team</h2>

          <div class="hero-sub">
            <p v-html="$t('homepage.header.line_1')"></p>
            <p v-html="$t('homepage.header.line_2')"></p>
          </div>
        </div>

        <div class="hero-logo">
          <img
            src="@/assets/img/logo/white.svg"
            alt="AGH Solar Boat"
          />
        </div>
      </div>

      <div class="hero-bottom">
        <a
          href="https://krakowsolarboatchallenge.agh.edu.pl"
          target="_blank"
          rel="noopener noreferrer"
          class="hero-btn"
        >
          <span class="btn-arrow">→</span>
          <span class="btn-text">{{ $t('homepage.header.competitions') }}</span>
        </a>
        <router-link to="/rekrutacja" class="hero-btn">
          <span class="btn-arrow">→</span>
          <span class="btn-text">{{ $t('homepage.header.recruitment') }}</span>
        </router-link>

        <a href="#projects-block" class="scroll-down" aria-label="Przewiń">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M12 4v16m0 0l-6-6m6 6l6-6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </v-container>
  </header>
</template>

<script>
export default {
  name: "Header"
}
</script>

<style lang="sass" scoped>
  #welcome-header
    position: relative
    min-height: 100vh
    color: #fff
    overflow: hidden
    display: flex
    background: #0a0828

  .hero-bg
    position: absolute
    inset: 0
    z-index: 0
    overflow: hidden
    background: #0a0828

    .hero-video-fill
      position: absolute
      top: 50%
      left: 50%
      min-width: 100%
      min-height: 100%
      width: auto
      height: auto
      max-width: none
      transform: translate(-50%, -50%)
      object-fit: cover
      display: block
      filter: blur(3px) saturate(1.15) brightness(0.82) contrast(1.05)

    .hero-overlay
      position: absolute
      inset: 0
      background: linear-gradient(180deg, rgba(10, 8, 40, 0.4) 0%, rgba(10, 8, 40, 0.4) 35%, rgba(10, 8, 40, 0.6) 75%, rgba(10, 8, 40, 0.96) 100%)

    .hero-grain
      position: absolute
      inset: 0
      pointer-events: none
      opacity: 0.32
      mix-blend-mode: overlay
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.55 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>")
      background-repeat: repeat
      background-size: 160px 160px

  .hero-content
    position: relative
    z-index: 2
    display: flex
    flex-direction: column
    width: 100%
    padding: clamp(96px, 16vw, 130px) 0 clamp(36px, 5vw, 60px)

  .hero-top
    display: flex
    align-items: baseline
    flex-wrap: wrap
    gap: 12px 28px
    padding-bottom: 18px
    border-bottom: 1px solid rgba(255, 255, 255, 0.2)

    .brand-mark
      font-family: Inter, sans-serif
      font-weight: 800
      font-size: clamp(0.72em, 2.4vw, 0.95em)
      letter-spacing: 0.18em
      color: #fff
      flex-shrink: 0

    .brand-meta
      font-family: Inter, sans-serif
      font-weight: 500
      font-size: clamp(0.72em, 2.2vw, 0.82em)
      letter-spacing: 0.04em
      color: rgba(255, 255, 255, 0.7)
      line-height: 1.45
      min-width: 0

  .hero-mid
    flex: 1
    display: grid
    grid-template-columns: minmax(0, 1fr) auto
    align-items: center
    gap: clamp(48px, 7vw, 120px)
    padding: clamp(32px, 6vw, 80px) 0
    width: 100%

  .hero-copy
    max-width: 920px
    min-width: 0

  .hero-logo
    display: flex
    align-items: center
    justify-content: flex-end
    padding-right: 12px
    flex-shrink: 0

    img
      width: clamp(160px, 18vw, 300px)
      height: auto
      max-height: clamp(90px, 12vw, 150px)
      object-fit: contain
      opacity: 0.95

  .hero-title,
  .hero-team
    font-family: Raleway, sans-serif
    font-weight: 900
    letter-spacing: -0.045em
    text-transform: uppercase
    color: #fff
    margin: 0
    text-rendering: geometricPrecision

  .hero-title
    display: flex
    flex-wrap: wrap
    align-items: baseline
    column-gap: 0.16em
    row-gap: 0.05em
    font-size: clamp(2.1rem, 9vw, 8rem)
    line-height: 0.95
    max-width: 100%

    .hero-title-agh,
    .hero-title-solar
      flex-shrink: 0
      white-space: nowrap

  .hero-team
    font-size: clamp(1.9rem, 8.4vw, 8rem)
    line-height: 0.92
    color: rgba(255, 255, 255, 0.55)
    margin-bottom: clamp(16px, 3vw, 36px)

  .hero-sub
    max-width: min(460px, 100%)

    p
      font-family: Inter, sans-serif
      font-size: clamp(0.88rem, 2.6vw, 1em)
      line-height: 1.7em
      color: rgba(255, 255, 255, 0.78)
      margin: 0 0 6px
      white-space: normal !important
      letter-spacing: 0 !important
      text-align: left !important

  .hero-bottom
    display: flex
    align-items: center
    gap: clamp(20px, 5vw, 56px)
    padding-top: 26px
    border-top: 1px solid rgba(255, 255, 255, 0.2)
    flex-wrap: wrap

  .hero-btn
    display: inline-flex
    align-items: center
    gap: 14px
    font-family: Inter, sans-serif
    font-weight: 700
    font-size: clamp(0.68em, 2.2vw, 0.82em)
    letter-spacing: 0.22em
    text-transform: uppercase
    color: #fff
    text-decoration: none
    transition: opacity 0.3s, gap 0.3s

    &:hover
      opacity: 0.75
      gap: 18px

    .btn-arrow
      font-family: Raleway, sans-serif
      font-weight: 700
      font-size: 1.6em
      line-height: 1
      letter-spacing: 0

  .scroll-down
    margin-left: auto
    width: 48px
    height: 48px
    border-radius: 50%
    background: #0a0828
    color: #fff
    display: inline-flex
    align-items: center
    justify-content: center
    text-decoration: none
    transition: all 0.3s ease

    &:hover
      background: #fff
      color: #0a0828
      transform: translateY(2px)

  @media only screen and (max-width: 1200px)
    .hero-mid
      grid-template-columns: 1fr
      align-items: start
      gap: clamp(24px, 4vw, 40px)

    .hero-logo
      justify-content: flex-start
      padding-right: 0
      margin-top: clamp(16px, 4vw, 28px)

      img
        width: clamp(220px, 38vw, 340px)
        max-height: clamp(90px, 12vw, 130px)

  @media only screen and (max-width: 599px)
    .hero-logo img
      width: clamp(200px, 62vw, 300px)
      max-height: clamp(80px, 18vw, 110px)

    .hero-top
      flex-direction: column
      align-items: flex-start
      gap: 8px

    .hero-mid
      padding: clamp(24px, 6vw, 40px) 0

    .hero-team
      margin-bottom: clamp(8px, 2vw, 14px)

    .hero-sub
      padding-top: clamp(10px, 3vw, 16px)

    .hero-bottom
      flex-direction: column
      align-items: flex-start
      gap: 20px

      .scroll-down
        margin-left: 0
        align-self: flex-start
</style>
